import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    sessionTreeActiveItem: {
      width: '302px',
      background: 'rgba(202, 202, 252, 0.3)',
    },
    ArrowDropDownIcon: {
      width: '22px',
      cursor: 'pointer',
    },
    editButton: {
      position: 'absolute',
      top: '144px',
      left: '830px',
      width: '84px',
      height: '30px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontSize: '12px',
      color: '#81818D',
      border: 'solid 1px rgba(44, 45, 62, 0.3)',
    },
    editButtonIcon: {
      width: '14px',
      justifyContent: 'start',
      color: '#81818D',
      transform: 'translateX(0px)',
      alignSelf: 'flex-end',
    },
    headerEditButtonIcon: {
      position: 'relative',
      top: '-56px',
      left: '275px',
      width: '12px',
      height: '12px',
      padding: '5px',
      color: 'rgba(60, 65, 154, 0.7)',
      background: 'rgba(202, 202, 252, 0.7)',
      borderRadius: '100px',
      cursor: 'pointer',
    },
    sessionTreeEditIcon: {
      width: '12px',
      height: '12px',
      padding: '5px',
      color: 'rgba(60, 65, 154, 0.7)',
      cursor: 'pointer',
      '&:hover': {
        borderRadius: '60px',
        backgroundColor: '#CACAFCB2',
      },
    },
    sessionTreeTextItem: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      padding: '5px',
      flexGrow: 2,
      margin: '0',
    },
    sessionTreeItem: {
      paddingRight: '15px',
      display: 'flex',
      alignItems: 'center',
    },
    sessionTreeItemTooltipContainer: {
      display: 'flex',
      width: '100%',
    },
    dragOverDropValid: {
      borderBottom: 'solid 2px #3C419A',
      marginTop: '-2px',
    },
  }),
);
